export const TaxCodeValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.vc_Code.trim()) {
      errors.vc_Code = 'Code is required';
    } 
    if (!formData.dec_Rate.trim()) {
        errors.dec_Rate = 'Dec Rate is required';
      } 
  
    return errors;
  };
  
 